var _desc, _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlueGem(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "62px",
    height: "83px",
    viewBox: "0 0 62 83",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "svg/BLUE GEM") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), /*#__PURE__*/React.createElement("g", {
    id: "BLUE-GEM",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BLUE-Gem",
    transform: "translate(2.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5752846,79.3148148 C24.5509465,79.3662037 34.408858,79.7636111 44.4286763,79.8321296 C47.6962483,74.9467593 53.0502092,71.2673148 57.0022051,66.9575 C58.0362003,51.6025 58.3968107,35.6959259 57.0684396,20.3649074 C52.1229252,15.9112037 47.7551235,10.9915741 42.9494376,6.2912037 C33.1908779,6.38712963 23.2777709,6.65777778 13.5118519,6.59953704 C10.6748045,9.64175926 7.76784294,12.9751852 4.91607682,16.0242593 C3.52883059,17.5111111 2.45435871,18.9705556 0.831611797,20.2175926 C-0.88680727,36.0762037 1.15174554,52.2431481 0.872088477,68.1325926 L1.18118313,68.4272222 C5.30612483,72.0724074 10.4577023,75.6662037 14.5716049,79.3216667",
    id: "SHADOW",
    stroke: "#000000",
    strokeWidth: 2.5,
    fill: "#000000",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5752846,73.3148148 C24.5509465,73.3662037 34.408858,73.7636111 44.4286763,73.8321296 C47.6962483,68.9467593 53.0502092,65.2673148 57.0022051,60.9575 C58.0362003,45.6025 58.3968107,29.6959259 57.0684396,14.3649074 C52.1229252,9.9112037 47.7551235,4.99157407 42.9494376,0.291203704 C33.1908779,0.38712963 23.2777709,0.657777778 13.5118519,0.599537037 C10.6748045,3.64175926 7.76784294,6.97518519 4.91607682,10.0242593 C3.52883059,11.5111111 2.45435871,12.9705556 0.831611797,14.2175926 C-0.88680727,30.0762037 1.15174554,46.2431481 0.872088477,62.1325926 L1.18118313,62.4272222 C5.30612483,66.0724074 10.4577023,69.6662037 14.5716049,73.3216667",
    id: "STROKE_dbc41132-9eda-410f-bc4a-6271284aa847",
    stroke: "#000000",
    strokeWidth: 2.5,
    fill: "#2FB3CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5154012,63.8044444 C33.0547291,63.5714815 26.6152572,63.9209259 21.0993896,63.6674074 C18.5236008,61.2178704 15.7196708,58.83 13.0776475,56.4489815 C12.9746159,45.3318519 12.0841289,33.8378704 12.5293724,22.5528704 C12.5808882,21.275 12.4042627,19.932037 13.1696399,19.2023148 C15.1824348,17.2769444 19.7930967,11.7680556 19.7930967,11.7680556 C19.7930967,11.7680556 23.4985528,11.7680556 26.1405761,11.7303704 C30.7218004,11.6721296 38.2283848,11.8057407 38.2283848,11.8057407 C38.2283848,11.8057407 44.3146056,16.1806481 45.7901646,18.362963 C47.0081447,30.8710185 45.1940535,43.6805556 45.6981722,56.1783333 C43.7258539,58.9019444 40.6937826,61.2247222 38.53012,63.8044444",
    id: "STROKE_ef3a26b0-d819-4a38-90ef-3be6a7495abf",
    stroke: "#6ECCDE",
    strokeWidth: 2.05555556,
    fill: "#49C3DA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(3.546831, 3.240185)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.640641598,12.5754886 C3.64327534,13.7985442 5.7959225,13.8277778 8.52993827,15.5133333",
    id: "STROKE_41d77d90-dfc1-4029-b062-b02827c2157d",
    stroke: "#6ECCDE",
    strokeWidth: 2.05555556,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4896813,0.416308955 C13.4362417,3.41399414 13.0596468,5.06425926 15.5655213,7.82555556 L11.4896813,0.416308955 Z",
    id: "STROKE_83ebc2b5-c536-4deb-8b08-c5b93d66b053",
    stroke: "#6ECCDE",
    strokeWidth: 2.05555556,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0667212,0.00761754919 C37.1578358,2.91965459 35.8921742,5.74259259 34.6521159,8.56555556",
    id: "STROKE_f3893580-ff6e-4812-97cf-1ffd3b492b60",
    stroke: "#6ECCDE",
    strokeWidth: 2.05555556,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7216941,14.6431481 C45.4427543,13.9045747 46.9149019,13.4907509 47.1381369,13.4016768 C49.2934393,12.6105724 50.4078875,12.1967486 50.4814815,12.1602054",
    id: "STROKE_9c892f25-7662-47b1-8287-94e77eff1368",
    stroke: "#6ECCDE",
    strokeWidth: 2.05555556,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.640641598,57.6431156 C3.86037754,56.3104304 5.80328189,55.6857407 8.77647805,53.8494444",
    id: "STROKE_293476dc-d3db-41a5-8361-42ee2a338931",
    stroke: "#6ECCDE",
    strokeWidth: 2.05555556,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5689999,67.0442386 C13.9604706,64.4603818 14.8078872,63.1839326 16.6915089,60.8862963",
    id: "STROKE_edce934f-2185-49db-b46d-8c732cf1c43a",
    stroke: "#6ECCDE",
    strokeWidth: 2.05555556,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9464918,61.0884259 C34.9584996,61.1115781 34.9683483,61.1356481 34.9759294,61.1603704 L35.1525549,61.4584259 C35.2666255,61.6468519 35.4138134,61.8798148 35.5867593,62.1436111 C35.7597051,62.4074074 36.2454252,63.1713889 37.0365604,64.3567593 C37.8276955,65.5421296 39.1498621,67.5704308 39.1976982,67.6458011",
    id: "STROKE_d08af9a3-ce52-427b-aebe-26afb04ff789",
    stroke: "#6ECCDE",
    strokeWidth: 2.05555556,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7143347,53.6301852 C42.8958495,53.7547328 46.5449005,55.3568519 46.942308,55.5384259 C47.3397154,55.72 49.8709589,56.7670038 50.0218265,56.8252445",
    id: "STROKE_f59ce1e0-d52b-44e3-8d52-e21787c4d453",
    stroke: "#6ECCDE",
    strokeWidth: 2.05555556,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.07430384,10.5046296 C5.08955414,10.4704863 5.10066205,10.4348644 5.10742112,10.3984259 C5.10742112,10.3984259 5.72561043,9.59333333 6.94727023,8.02083333 L8.94902606,5.46851852",
    id: "STROKE_81aa6f71-1cca-4f5f-9ddd-6b1bbd704623",
    stroke: "#6ECCDE",
    strokeWidth: 2.05555556,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.608251,43.0375926 C46.608251,43.0752778 46.608251,43.5583333 46.5677743,44.4833333 C46.5272977,45.4083333 46.5677743,47.8887037 46.6045713,48.3580556 C46.6337382,48.8354736 46.6226652,49.3142858 46.571454,49.7900926 C46.5199383,50.28 46.4757819,50.6157407 46.4353052,50.7938889",
    id: "STROKE_d81cdd5e-bd38-48ca-bb0a-592f513ab303",
    stroke: "#6ECCDE",
    strokeWidth: 2.05555556,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#6ECCDE",
    cx: 12.8888889,
    cy: 19,
    rx: 1.07407407,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#6ECCDE",
    cx: 34.0457613,
    cy: 56.7598148,
    rx: 1.07407407,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#76CFE0",
    cx: 19.0087243,
    cy: 5.75981481,
    rx: 1.07407407,
    ry: 1
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueGem);
export default __webpack_public_path__ + "static/media/blueGem.b8f1942ce196cbd10532e09e96efae1c.svg";
export { ForwardRef as ReactComponent };